__turbopack_context__.v({
  "cross": "ModalCard-module__6ofKna__cross",
  "modalCard": "ModalCard-module__6ofKna__modalCard",
});
